import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { select } from '@ngxs/store';

import { FormsModule } from '@angular/forms';
import { params } from '@app/configurations';
import { GoTo } from '@app/core/store/states/router-nav/router-nav-state.actions';
import { RouterPath } from '@app/core/store/states/router-nav/router-nav-state.model';
import { RouterNavState } from '@app/core/store/states/router-nav/router-nav.state';
import { HeapDirective } from '@app/shared/directives/heap.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { NzSwitchModule } from 'ng-zorro-antd/switch';

@Component({
  selector: 'adspt-conversion-delay-switch',
  templateUrl: 'conversion-delay-switch.component.html',
  styleUrls: ['conversion-delay-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, HeapDirective, NzSwitchModule, FormsModule],
})
export class ConversionDelaySwitchComponent {
  readonly delay = select(RouterNavState.queryBooleanParam(params.DELAY, true));

  @Dispatch()
  readonly setDelay = (delay: boolean) =>
    new GoTo(RouterPath._, { queryParams: { [params.DELAY]: delay ? null : 'false' } });

  toggleDelay(): void {
    this.setDelay(!this.delay());
  }
}
